export const GET_SETTINGS_DATA = 'GET_SETTINGS_DATA'
export const GET_SETTINGS_DATA_RES = 'GET_SETTINGS_DATA_RES'
export const SAVE_SETTINGS_DATA = 'SAVE_SETTINGS_DATA'
export const SAVE_SETTINGS_DATA_RES = 'SAVE_SETTINGS_DATA_RES'
export const REQUEST_CANCEL = 'REQUEST_CANCEL'
